var map = {
	"./MasterCard.png": 230,
	"./Stripe.png": 232,
	"./Visa.png": 231,
	"./email.png": 579,
	"./location.png": 580,
	"./phone.png": 581,
	"./whatsapp.png": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;